export function getHostUrl(env: string): string {
    switch (env) {
      case 'azt':
        return 'https://ncmstest.westeurope.cloudapp.azure.com/ccms-azt/web/api/';
        //return 'https://ncmspvm.westeurope.cloudapp.azure.com/web/api/';
      case 'azl':
        return 'https://ncmstest.westeurope.cloudapp.azure.com/web/api/';
      case 'production':
        return 'https://ncmspvm.westeurope.cloudapp.azure.com/web/api/';
      default:
        return 'http://localhost/web/api/';
    }
  }
  